export default "__VITE_ASSET__a1wLAjpQ__"